<template>
  <!-- SEÇÃO: FAQ -->
  <section id="faq" class="mt-10 mb-10 md:px-4 xl:px-0">
    <div class="max-w-screen-xl mx-auto px-2 md:px-0">
      <!-- Título -->
      <div class="mb-8">
        <div class="flex items-center gap-2 relative pb-3">
          <div>
            <h2
              class="text-lg md:text-xl font-medium tracking-wide"
              :style="{ color: customization?.section_title_color || '#1c243b' }"
            >
              {{ customization?.faq_title || 'Perguntas frequentes' }}
            </h2>
            <h2
              v-if="customization?.faq_subtitle"
              class="text-xs md:text-sm font-normal tracking-wide"
              :style="{ color: customization?.section_subtitle_color || '#666666' }"
            >
              {{ customization.faq_subtitle }}
            </h2>
          </div>
          <div class="absolute bottom-0 left-0 w-full h-px bg-gray-200"></div>
          <div
            class="absolute bottom-0 left-0 h-px w-full max-w-[480px]"
            :style="{ backgroundColor: customization?.section_divider_color || '#e5e7eb' }"
          ></div>
        </div>
      </div>

      <!-- Acordeão -->
      <div v-if="faqItems && faqItems.length > 0" class="w-full space-y-3">
        <div
          v-for="(item, index) in faqItems"
          :key="index"
          class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden transition-all duration-300"
        >
          <button
            @click="toggleFaq(index)"
            class="w-full px-4 py-5 text-left flex items-center justify-between focus:outline-none"
            :aria-expanded="item.open"
          >
            <!-- Pergunta com font_color fixa (sem hover) -->
            <span
              class="font-medium text-sm pr-6 leading-relaxed"
              :style="{ color: fontColor }"
            >
              {{ item.question }}
            </span>

            <!-- Ícone de seta com a mesma cor -->
            <svg
              class="w-5 h-5 flex-shrink-0 transition-transform duration-300"
              :class="{ 'rotate-180': item.open }"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              :style="{ color: fontColor }"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <!-- Resposta -->
          <transition
            enter-active-class="transition-all duration-300 ease-out"
            leave-active-class="transition-all duration-200 ease-in"
            enter-from-class="opacity-0 max-h-0"
            enter-to-class="opacity-100 max-h-96"
            leave-from-class="opacity-100 max-h-96"
            leave-to-class="opacity-0 max-h-0"
          >
            <div
              v-show="item.open"
              class="px-6 pb-5 pt-2 text-gray-600 text-sm leading-relaxed border-t border-gray-100"
              v-html="item.answer"
            ></div>
          </transition>
        </div>
      </div>

      <!-- Sem perguntas -->
      <div v-else class="text-center py-12">
        <p class="text-gray-500">Nenhuma pergunta cadastrada ainda.</p>
      </div>

      <!-- Mensagem de suporte -->
      <div v-if="settings?.faq_support_message" class="text-center mt-10">
        <p class="text-sm text-gray-500" v-html="settings.faq_support_message"></p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useLandingPage } from '@/composables/useLandingPage'

const { faqs, customization, settings } = useLandingPage()

// Usa exatamente a mesma cor do texto principal
const fontColor = computed(() => customization.value?.font_color || '#1f2937')

const faqItems = ref([])

watch(faqs, (newFaqs) => {
  if (newFaqs && newFaqs.length > 0) {
    faqItems.value = newFaqs.map(faq => ({
      question: faq.question,
      answer: faq.answer,
      open: false
    }))
  }
}, { immediate: true })

const toggleFaq = (index) => {
  faqItems.value.forEach((item, i) => {
    item.open = i === index ? !item.open : false
  })
}
</script>

<style scoped>
.max-h-96 { max-height: 24rem; }
</style>